import { NgModule } from '@angular/core';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { RouterModule } from '@angular/router';
import { TextoComprasComponent } from './textocompras.component';
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';


@NgModule({
    imports: [
        AngularFontAwesomeModule,
        RouterModule,
        CommonModule,
        BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [
        TextoComprasComponent
    ],
  
    declarations: [
        TextoComprasComponent
    ],
    providers: [
      
    ],
    entryComponents: [
        TextoComprasComponent,
    ],
  
  })
  export class TextoComprasModule { }

    // required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }